import { Injectable, Injector } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountAdminGuard } from './account-admin.guard';
import { Observable, switchMap } from 'rxjs';
import { GuardPermissionsService } from '../services/guard-permissions.service';

@Injectable({
    providedIn: 'root'
})

export class EventHistoryGuard  {

    constructor(
        private route: Router,
        private guardPermissionsService: GuardPermissionsService,
        private injector: Injector,
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const parentRouteGuard =  this.injector.get(AccountAdminGuard);
        return parentRouteGuard.canActivate(next, state)
            .pipe(
                switchMap(async (result) => {
                    let satisfiedRequirements = [];
                    //If Admin guard says no - don't bother checking if other requirements have been satisfied
                    if ( result ) {
                        satisfiedRequirements = await this.guardPermissionsService.determineSatisfiedRequirementsForEventHistory(this.route);
                        if(satisfiedRequirements && satisfiedRequirements.length > 0){
                            next.data = { shell: 'accounts', satisfiedRequirements: satisfiedRequirements };
                            console.log("Event History access permitted: ", satisfiedRequirements);
                            return Promise.resolve(true);
                        }
                    }
                    console.error("Event History access not permitted");
                    this.route.navigate(['navigationError']);
                    return Promise.resolve(false);
                })
            );
    }
}